import React from 'react';
import PropTypes from 'prop-types';
import { FaWindowClose } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import {
  ModalBackdrop,
  ModalContent,
  ModalHeader,
  CloseButton,
  ModalTabs,
  TabItem,
  ModalForm,
  TabContent,
  FormGroup,
  GapForm,
  TopMargin,
  ErrorMessage,
  Spinner,
  ModalFooter,
  CancelButton,
  ContinueButton,
} from "./FeedbackModalStyles";

const FeedbackModalUI = ({
  activeTab,
  title,
  priority,
  severity,
  reproSteps,
  description,
  errorMessage,
  feedbackId,
  onClose,
  onTabChange,
  onTitleChange,
  onPriorityChange,
  onSeverityChange,
  onReproStepsChange,
  onDescriptionChange,
  onSubmit,
  loading,
}) => {
  const { t } = useTranslation('feedbackModalUI');

  return (
    <ModalBackdrop>
      <ModalContent>

        <ModalHeader>
          <h2>{t('title')}</h2>
          <CloseButton onClick={onClose}>
            <FaWindowClose />
          </CloseButton>
        </ModalHeader>

        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

        {/* Tabs */}
        <ModalTabs>
          <TabItem active={activeTab === 'Bug'} onClick={() => onTabChange('Bug')}>
            {t('tabs.bug')}
          </TabItem>
          <TabItem active={activeTab === 'Task'} onClick={() => onTabChange('Task')}>
            {t('tabs.task')}
          </TabItem>
        </ModalTabs>

        {/* Modal Body */}
        <TabContent>
          <ModalForm onSubmit={onSubmit}>
            <FormGroup>
              <label>{t('form.titleLabel')}</label>
              <input
                type="text"
                value={title}
                onChange={(e) => onTitleChange(e.target.value)}
              />
            </FormGroup>

            {activeTab === 'Bug' && (
              <TopMargin>
                <GapForm>
                  <FormGroup>
                    <label>{t('form.priorityLabel')}</label>
                    <select
                      value={priority}
                      onChange={(e) => onPriorityChange(e.target.value)}
                    >
                      {[1,2,3,4,5].map(n => (
                        <option key={n} value={String(n)}>
                          {n}
                        </option>
                      ))}
                    </select>
                  </FormGroup>

                  <FormGroup>
                    <label>{t('form.severityLabel')}</label>
                    
                    <select
                      value={severity}
                      onChange={(e) => onSeverityChange(e.target.value)}>
                      {[
                        "1 - Critical",
                        "2 - High",
                        "3 - Medium",
                        "4 - Low"
                      ].map(s => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </FormGroup>

                  <FormGroup>
                    <label>{t('form.stepsLabel')}</label>
                    <textarea
                      rows="4"
                      value={reproSteps}
                      onChange={(e) => onReproStepsChange(e.target.value)}
                    />
                  </FormGroup>
                </GapForm>
              </TopMargin>
            )}

            {activeTab === 'Task' && (
              <TopMargin>
                <FormGroup>
                  <label>{t('form.descriptionLabel')}</label>
                  <textarea
                    rows="4"
                    value={description}
                    onChange={(e) => onDescriptionChange(e.target.value)}
                  />
                </FormGroup>
              </TopMargin>
            )}

            {/* Show spinner when loading */}
            {loading && <Spinner />}

            {/* Modal Footer */}
            <TopMargin>
              <ModalFooter>
              <CancelButton type="button" onClick={onClose} disabled={loading}>
                  {t('buttons.close')}
                </CancelButton>
                <ContinueButton type="submit" disabled={loading}>
                  {t('buttons.submit')}
                </ContinueButton>
              </ModalFooter>
            </TopMargin>
          </ModalForm>
        </TabContent>
      </ModalContent>
    </ModalBackdrop>
  );
};

FeedbackModalUI.propTypes = {
  activeTab: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  priority: PropTypes.string,
  severity: PropTypes.string,
  reproSteps: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  feedbackId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
  onTitleChange: PropTypes.func.isRequired,
  onPriorityChange: PropTypes.func,
  onSeverityChange: PropTypes.func,
  onReproStepsChange: PropTypes.func,
  onDescriptionChange: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

FeedbackModalUI.defaultProps = {
  activeTab: 'Bug',
};

export default FeedbackModalUI;
